module.exports = __webpack_public_path__ + "static/img/app2@2x.3e7e8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app2@2x.png
// module id = YrJc
// module chunks = 2